import { render } from "./DynamicComponentView.vue?vue&type=template&id=a4c476dc&scoped=true"
import script from "./DynamicComponentView.vue?vue&type=script&lang=js"
export * from "./DynamicComponentView.vue?vue&type=script&lang=js"

import "./DynamicComponentView.vue?vue&type=style&index=0&id=a4c476dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4c476dc"]])

export default __exports__